import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';

/**
 * A status assertion recorded for the event's subject.
 */
export class ActivityStatusChangeDto {
  status!: string;
  scope!: string;
  sourceSubject!: AppSubjectEnum;
  sourceId!: number;
  effectiveFrom?: Date;
  effectiveTo?: Date;
}
